import axios from 'axios';
import { bindValidator } from '../validators';

/**
 * /novo-app: inscrição de testador sem recarregar a página. Posta em
 * POST /api/testadores e, dando certo, troca o form pelos passos (já
 * renderizados no Blade) da plataforma escolhida.
 */
const form = document.querySelector<HTMLFormElement>('[data-novo-app-form]');
const sucesso = document.querySelector<HTMLElement>('[data-novo-app-sucesso]');

type Passo = { chave: string; url: string | null };
type Resposta = { data: { plataforma: string; passos: Passo[] } };

if (form && sucesso) {
    const validator = bindValidator(form);
    const erro = form.querySelector<HTMLElement>('[data-novo-app-erro]');
    const enviar = form.querySelector<HTMLButtonElement>('button[type="submit"]');
    const campo = (nome: string) => form.querySelector<HTMLInputElement>(`[name="${nome}"]`);

    const mostrarErro = (mensagem: string | null) => {
        if (!erro) return;
        erro.textContent = mensagem ?? '';
        erro.hidden = !mensagem;
    };

    const mostrarPassos = (resposta: Resposta) => {
        const { plataforma, passos } = resposta.data;

        sucesso.querySelectorAll<HTMLElement>('.passos').forEach((lista) => {
            lista.hidden = lista.dataset.plataforma !== plataforma;
        });

        // Os links vêm do servidor; a resposta prevalece sobre o HTML renderizado.
        passos.forEach((passo) => {
            const link = sucesso.querySelector<HTMLAnchorElement>(`[data-passo="${passo.chave}"]`);
            if (link && passo.url) link.href = passo.url;
        });

        form.hidden = true;
        sucesso.hidden = false;
        sucesso.scrollIntoView({ behavior: 'smooth', block: 'start' });
        sucesso.focus({ preventScroll: true });
    };

    const email = campo('email');
    email?.addEventListener('blur', () => {
        email.value = email.value.trim();
    });

    form.addEventListener('submit', async (e) => {
        e.preventDefault();
        mostrarErro(null);

        if (email) email.value = email.value.trim();
        if (!validator.validate()) return;

        const params = new URLSearchParams(window.location.search);
        const plataforma = form.querySelector<HTMLInputElement>('[name="plataforma"]:checked')?.value ?? 'android';

        const payload = {
            nome: campo('nome')?.value ?? '',
            email: email?.value ?? '',
            whatsapp: campo('whatsapp')?.value ?? '',
            plataforma,
            consentimento: campo('consentimento')?.checked ?? false,
            website: campo('website')?.value ?? '',
            origem: params.get('origem') ?? (document.referrer ? new URL(document.referrer).hostname : 'site'),
            utm_source: params.get('utm_source'),
            utm_medium: params.get('utm_medium'),
            utm_campaign: params.get('utm_campaign'),
        };

        enviar?.classList.add('button--loading');
        if (enviar) enviar.disabled = true;

        try {
            const { data } = await axios.post<Resposta>('/api/testadores', payload, {
                headers: { Accept: 'application/json' },
            });
            mostrarPassos(data);
        } catch (error) {
            const resposta = axios.isAxiosError<{ errors?: Record<string, string[]>; message?: string }>(error)
                ? error.response
                : undefined;

            if (resposta?.status === 422 && resposta.data?.errors) {
                const erros = resposta.data.errors;
                let semCampo: string | null = null;

                Object.entries(erros).forEach(([nome, mensagens]) => {
                    const input = campo(nome);
                    if (input && input.type !== 'hidden') validator.addError(input, mensagens[0]);
                    else semCampo = mensagens[0];
                });

                mostrarErro(semCampo);
            } else if (resposta?.status === 429) {
                mostrarErro(resposta.data?.message ?? 'Muitas tentativas. Aguarde um minuto e tente novamente.');
            } else {
                mostrarErro('Não foi possível concluir a inscrição agora. Verifique a sua conexão e tente novamente.');
            }
        } finally {
            enviar?.classList.remove('button--loading');
            if (enviar) enviar.disabled = false;
        }
    });
}
